<template>
  <DataLoadingIcon :icon-class-addition="[iconSize]" />
</template>
<script>
import DataLoadingIcon from '@/components/DataLoading/DataLoadingIcon'

export default {
  components: {DataLoadingIcon},
  props: {
    size: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'fa-lg', 'fa-2x', 'fa-3x', 'fa-4x', 'fa-5x'].indexOf(value) !== -1
    }
  },
  computed: {
    iconSize() {
      return this.size === 'normal' ? '' : this.size
    }
  }
}
</script>
